(() => {
  const quickview = document.querySelector('[data-quickview]');
  if (!quickview) return;

  const panel = quickview.querySelector('[role="dialog"]');
  const body = quickview.querySelector('[data-quickview-body]');
  const closeBtn = quickview.querySelector('.preorder-quickview__close');
  let lastFocused = null;

  const close = () => {
    quickview.hidden = true;
    document.body.classList.remove('storefront-lightbox-open');
    body.replaceChildren();
    lastFocused?.focus();
  };

  const open = (templateId, trigger) => {
    const template = document.getElementById(templateId);
    if (!template) return;

    body.replaceChildren(template.content.cloneNode(true));
    const title = body.querySelector('[data-quickview-title]');
    if (title) panel.setAttribute('aria-label', title.textContent.trim());
    window.lqProduct?.bindGallery(body);
    window.lqProduct?.bindForm(body, { onAdded: close });

    quickview.hidden = false;
    document.body.classList.add('storefront-lightbox-open');
    lastFocused = trigger;
    closeBtn?.focus();
  };

  document.querySelectorAll('[data-quickview-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => open(trigger.getAttribute('data-quickview-open'), trigger));
  });

  quickview.querySelectorAll('[data-quickview-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (event) => {
    if (!quickview.hidden && event.key === 'Escape') close();
  });
})();
